var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('fa-icon',{attrs:{"icon":"layer-group"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.layer.title))]),_vm._v(" "),(_vm.winterRoutesLength)?_c('counter',[_vm._v(_vm._s(_vm.winterRoutesLength))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }